import { useMissionsUrl } from '@/features/missions/context/MissionsUrlProvider'
import { Button, Text } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { useNavigate } from 'react-router-dom'

export const NectarTasksAllDone = ({ name, pointsAmount }: { name: string; pointsAmount?: number }) => {
  const { missionsUrl } = useMissionsUrl()
  const navigate = useNavigate()
  const onBackToMissions = () => navigate(missionsUrl)

  return (
    <div className="mt-20">
      <div className="relative mx-auto flex w-[600px] flex-col items-center justify-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center max-md:w-full max-md:gap-4">
        <img
          src={'/images/cup.webp'}
          alt={name}
          className="absolute top-0 left-0 h-[300px] w-[300px] translate-x-[-30%] translate-y-[-35%] max-md:h-[200px] max-md:w-[200px] max-md:translate-y-[-50%]"
        />
        <Text type="h5" className="text-gray-70">
          All Done!
        </Text>
        <div className="flex flex-col items-center justify-center">
          <Text type="body1-regular" className="text-gray-80">
            Your work has been submitted and is under review.
          </Text>
          {!!pointsAmount && (
            <Text type="body1-regular" className="text-gray-80">
              You will earn up to <span className="text-green">{formatNumber(pointsAmount, 0)} points</span> points
              after review!
            </Text>
          )}
        </div>
        <Button size="small" onClick={onBackToMissions} className="mt-2">
          Back to Missions
        </Button>
      </div>
    </div>
  )
}
